import { apiRequest } from '@/calls/helpers';

const getTerms = async (locale) => apiRequest(`routes/get_terms?lang=${locale}`, {
  method: 'GET',
});

export {
  // eslint-disable-next-line
  getTerms
};
